import { Component } from "react"
import PropTypes from "prop-types"

import * as $ from "jquery"

export default class SubmitForReview extends Component {
  constructor() {
    super()
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {
      readyForReview: false,
      failedTestsHtml: null,
    }
  }

  handleSubmit(event) {
    event.preventDefault()
    $.ajax({
      url: `/services/${this.props.service.slug}/publish/submit`,
      dataType: "json",
    }).done(response => {
      if (response.passed === false) {
        this.setState({ failedTestsHtml: response.failed_tests_html })
      } else if (response.progress.failed_tests.length == 0) {
        this.setState({ readyForReview: true })
      }
    })
  }

  submitBtn() {
    return (
      <button
        type="button"
        onClick={this.handleSubmit}
        className="button-secondary"
      >
        Submit for review
      </button>
    )
  }

  failingTestMessage() {
    return (
      <section className="failed-tests">
        <p>
          Before we can review your submission, please fix the red issues
          listed.
        </p>
        <div dangerouslySetInnerHTML={{ __html: this.state.failedTestsHtml }} />
      </section>
    )
  }

  successMessage() {
    return (
      <p>
        You&apos;re all set! We&apos;ve received your submission and will be in
        communication shortly.
      </p>
    )
  }

  render() {
    return (
      <section>
        {this.state.readyForReview ? (
          this.successMessage()
        ) : (
          <div>
            <span>
              {this.state.failedTestsHtml ? this.failingTestMessage() : ""}
            </span>
            <div className="action">
              {this.state.failedTestsHtml ? null : this.submitBtn()}
            </div>
          </div>
        )}
      </section>
    )
  }
}

SubmitForReview.propTypes = {
  service: PropTypes.object.isRequired,
}
